const projectsData = {
  projects: [
    {
      id: 1,
      name: "summarizer",
      title: "Summarizer",
      category: "AI ML",
      description:
        "An AI-powered text summarization tool using NLP to generate concise summaries from long documents.",
      technologies: ["Python", "NLP", "Streamlit", "Transformers"],
      liveLink: "https://summarizer-app-7bxbyjiv6u5mvkrhhwmzzv.streamlit.app/",
      github: "https://github.com/sh78ba/summarizer-app",
    },
    {
      id: 2,
      name: "netflixgpt",
      title: "NetflixGPT",
      category: "Web App",
      description:
        "An AI-powered Netflix clone that uses GPT to recommend movies based on natural language queries.",
      technologies: ["React", "OpenAI API", "TMDB API", "Tailwind CSS"],
      liveLink: "https://netflix-gpt-3kbp.vercel.app/",
      github: "https://github.com/sh78ba/netflix-gpt",
    },
    {
      id: 3,
      name: "smartportfolio",
      title: "Smart-Portfolio",
      category: "AI ML",
      description:
        "An intelligent portfolio management system using machine learning for investment recommendations.",
      technologies: ["React", "Python", "TensorFlow", "FastAPI"],
      liveLink: "https://smart-portfolio-frontend.vercel.app/",
      github: "https://github.com/sh78ba/smart-portfolio",
    },
    {
      id: 4,
      name: "devshort",
      title: "DevShort",
      category: "Web App",
      description:
        "A URL shortener service specifically designed for developers with analytics and custom domains.",
      technologies: ["Node.js", "Express", "MongoDB", "React"],
      liveLink: "https://github.com/sh78ba/DevShort",
      github: "https://github.com/sh78ba/DevShort",
    },
    {
      id: 5,
      name: "communityhub",
      title: "Community Hub",
      category: "Web App",
      description:
        "A social platform for communities to connect, share resources, and organize local events.",
      technologies: ["React", "Node.js", "PostgreSQL", "Socket.io"],
      liveLink: "https://project-community-frontend.vercel.app/home/index.html",
      github: "https://github.com/sh78ba/community-hub",
    },
    {
      id: 6,
      name: "perfin",
      title: "Perfin",
      category: "Web App",
      description:
        "A personal finance management application for tracking expenses, budgeting, and financial planning.",
      technologies: ["React", "Python", "SQLite", "Chart.js"],
      liveLink: "https://github.com/sh78ba/personal_finance",
      github: "https://github.com/sh78ba/personal_finance",
    },
    {
      id: 7,
      name: "portfolio",
      title: "Portfolio",
      category: "Web App",
      description:
        "A modern portfolio website showcasing projects and skills. Built with React and deployed on personal domain.",
      technologies: ["React", "JavaScript", "CSS", "Firebase"],
      liveLink: "https://sbdev.me",
      github: "https://github.com/sh78ba/portfolio",
    },
    {
      id: 8,
      name: "spamdetector",
      title: "SMS_Spam_Detector",
      category: "AI ML",
      description:
        "A web-based spam detection system that classifies messages as Spam or Ham using TF-IDF, Naive Bayes, Random Forest, and Stacking Ensemble. The model is trained on a dataset of SMS messages and deployed using Flask.",
      technologies: ["Python", "Scikit-learn", "NLP", "Flask"],
      liveLink: "https://sms-spam-detector-2ozk.onrender.com/",
      github: "https://github.com/sh78ba/SMS_Spam_Detector",
    },
    {
      id: 9,
      name: "Epilepsy Detection",
      title: "Epilepsy Detection",
      category: "AI ML",
      description:
        "A deep learning project that detects epileptic seizures from EEG brain signals using PyTorch with Streamlit deployment.",
      technologies: ["React", "FastAPI", "TCN", "streamlit"],
      liveLink: "https://epilepsy-detection.streamlit.app",
      github: "https://github.com/sh78ba/Epilepsy-Detection",
    },
    {
      id: 10,
      name: "shareplate",
      title: "SharePlate",
      category: "Web App",
      description:
        "SharePlate is a web-based platform that connects restaurants with volunteers to facilitate food donation and reduce food waste. Restaurants can create donation requests, and nearby volunteers can view and respond to these requests in real time.",
      technologies: ["React", "Node.js", "MongoDB", "Express"],
      liveLink: "https://rescuefoodfrontend.vercel.app/",
      github: "https://github.com/sh78ba/rescuefood",
    },
    {
      id: 11,
      name: "meprofiled",
      title: "MeProfiled",
      category: "AI ML",
      description:
        "An advanced AI-powered resume analysis tool that intelligently matches resumes with job descriptions using state-of-the-art NLP models, providing detailed insights and actionable feedback.",
      technologies: ["React", "Python", "AI/ML", "PostgreSQL"],
      liveLink: "https://me-profiled-frontend.vercel.app/",
      github: "https://github.com/sh78ba/MeProfiled",
    },
    {
      id: 12,
      name: "interviewa",
      title: "Interviewa",
      category: "AI ML",
      description:
        "An open-source, self-hostable full-stack AI interview practice platform that simulates technical coding, system design, and behavioral rounds with real-time voice interaction, resume-aware questioning, and detailed performance evaluation reports.",
      technologies: ["Next.js", "FastAPI", "Google Colab", "Python"],
      liveLink: "https://interviewa-chi.vercel.app/",
      github: "https://github.com/sh78ba/Interviewa",
    },
  ],

  skills: {
    languages: ["JavaScript", "Python", "Java", "SQL", "HTML/CSS"],
    frontend: ["React.js", "Tailwind CSS", "Redux", "Material-UI"],
    backend: ["Node.js", "Express", "Python/Flask", "MongoDB", "PostgreSQL"],
    aiml: ["Generative AI", "NLP", "Deep Learning", "TensorFlow", "PyTorch"],
    tools: ["Git", "Docker", "Firebase", "AWS", "Vercel"],
  },

  contact: {
    email: "sbasumatary.dev@gmail.com",
    phone: "+91-XXXXXXXXXX",
    location: "Bengaluru, India",
    website: "https://sbdev.me",
  },

  social: {
    github: "https://github.com/sh78ba",
    linkedin: "https://www.linkedin.com/in/sh78ba",
    twitter: "https://x.com/sh78ba",
    blog: "https://blog.sbdev.me",
    email: "sbasumatary.dev@gmail.com",
  },

  profile: {
    name: "Shantanu Basumatary",
    title: "Full Stack Developer & AI Enthusiast",
    bio: "MCA graduate from NIT Warangal with a passion for building scalable web applications and AI solutions. Currently working as an Associate Software Engineer at BDB.ai.",
    avatar: "👨‍💻",
  },

  experience: [
    {
      id: 2,
      year: "2026",
      month: "Jul",
      title: "Associate Software Engineer",
      company: "BDB.ai",
      description:
        "Leading the architecture and end-to-end development of scalable full stack web applications and advanced AI capabilities.",
    },
    {
      id: 1,
      year: "2026",
      month: "Jan",
      title: "Associate Software Engineer - Intern",
      company: "BDB.ai",
      description:
        "Collaborated with the engineering team to build and deploy robust web applications and integrate core AI product features.",
    },
  ],

  education: [
    {
      id: 1,
      year: "2026",
      month: "May",
      degree: "Master of Computer Applications",
      institution: "NIT Warangal",
      description:
        "Advanced coursework in full stack software engineering and AI/ML systems.",
    },
    {
      id: 2,
      year: "2023",
      month: "Jun",
      degree: "Bachelor of Science",
      institution: "Lalit Chandra Bharali College, Maligaon, Guwahati",
      description: "Computer Science (Honours)",
    },
    {
      id: 3,
      year: "2019",
      month: "May",
      degree: "12th",
      institution: "Cotton University, Guwahati",
      description: "Science(PCM)",
    },
    {
      id: 4,
      year: "2017",
      month: "May",
      degree: "10th",
      institution: "Sacred Heart High School, Rowta",
      description: "",
    },
  ],

  contacts: [
    {
      id: 1,
      label: "LinkedIn",
      value: "linkedin.com/in/sh78ba",
      link: "https://www.linkedin.com/in/sh78ba",
      icon: "bi bi-linkedin",
    },
    {
      id: 2,
      label: "GitHub",
      value: "github.com/sh78ba",
      link: "https://github.com/sh78ba",
      icon: "bi bi-github",
    },
    {
      id: 3,
      label: "Twitter",
      value: "@sh78ba",
      link: "https://x.com/sh78ba",
      icon: "bi bi-twitter-x",
    },
    {
      id: 5,
      label: "Gmail",
      value: "sbasumatary.dev@gmail.com",
      link: "https://mail.google.com/mail/?view=cm&fs=1&to=sbasumatary.dev@gmail.com",
      icon: "bi bi-envelope-fill",
    },
  ],

  home: {
    name: "Shantanu Basumatary",
    subtitle: "Full Stack Developer & AI Engineer",
    description:
      "I am Shantanu Basumatary (Shantanu, also known as Shantu), a full stack developer and AI engineer. I build fast, thoughtful products from modern frontends to intelligent backends on sbdev.me.",
  },

  socialLinks: [
    {
      id: 1,
      name: "LinkedIn",
      url: "https://in.linkedin.com/in/sh78ba",
      icon: "bi bi-linkedin",
    },
    {
      id: 2,
      name: "GitHub",
      url: "https://github.com/sh78ba",
      icon: "bi bi-github",
    },
    {
      id: 3,
      name: "Twitter",
      url: "https://x.com/sh78ba",
      icon: "bi bi-twitter-x",
    },
    {
      id: 4,
      name: "Blog",
      url: "https://blog.sbdev.me",
      icon: "bi bi-journal-text",
    },
  ],

  allSkills: [
    { id: 1, name: "C++", category: "Languages" },
    { id: 2, name: "Python", category: "Languages" },
    { id: 3, name: "JavaScript", category: "Languages" },
    { id: 4, name: "Java", category: "Languages" },
    { id: 5, name: "React.js", category: "Frontend" },
    { id: 6, name: "Next.js", category: "Frontend" },
    { id: 7, name: "Angular", category: "Frontend" },
    { id: 8, name: "Tailwind CSS", category: "Frontend" },
    { id: 9, name: "Node.js", category: "Backend" },
    { id: 10, name: "Express.js", category: "Backend" },
    { id: 11, name: "Spring Boot", category: "Backend" },
    { id: 12, name: "FastAPI", category: "Backend" },
    { id: 13, name: "MongoDB", category: "Database" },
    { id: 14, name: "PostgreSQL", category: "Database" },
    { id: 15, name: "MySQL", category: "Database" },
    { id: 16, name: "Firebase", category: "Database" },
    { id: 17, name: "TensorFlow", category: "AI" },
    { id: 18, name: "Scikit-learn", category: "AI" },
    { id: 19, name: "Streamlit", category: "AI" },
    { id: 20, name: "Apache Spark", category: "Data Streaming" },
    { id: 21, name: "Apache Kafka", category: "Data Streaming" },
    { id: 22, name: "Git", category: "Tools & DevOps" },
    { id: 23, name: "GitHub", category: "Tools & DevOps" },
    { id: 24, name: "GitLab", category: "Tools & DevOps" },
    { id: 25, name: "Docker", category: "Tools & DevOps" },
    { id: 26, name: "Jira", category: "Tools & DevOps" },
    { id: 27, name: "GitHub Copilot", category: "Tools & DevOps" },
    { id: 28, name: "Cursor IDE", category: "Tools & DevOps" },
    { id: 29, name: "AWS", category: "Cloud" },
  ],
};

// Sort projects in descending order by ID (highest ID first)
projectsData.projects.sort((a, b) => b.id - a.id);

export default projectsData;
